// Viral PnL auto-prompt event (MOR-540) — fires when a winning sell clears the
// threshold and the celebration share modal auto-opens. The funnel closes with
// the existing `pnl_card_shared` event when the user actually shares.

import type { EventDefinition } from './navigation';

export type ViralPnlAutoPromptedProperties = {
  marketPubkey: string;
  walletPubkey: string;
  outcomeIndex: number;
};

export const VIRAL_PNL_AUTO_PROMPTED: EventDefinition<ViralPnlAutoPromptedProperties> = {
  name: 'viral_pnl_auto_prompted',
};
